import React, { useEffect, useState } from 'react';
import styles from './ModuleForm.module.css';
import { ReactComponent as Close } from '../ico/close.svg';
import { Button } from '../../UI/Button/Button';
import { Input } from '../../UI/input/input';
import { TextArea } from '../../UI/TextArea/TextArea';
import { useApi } from '../../../hooks/useApi';
import { useStores } from '../../../hooks/useStore';
import { CourseModule } from '../../../models/courses';

interface ModuleFormProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  courseId: string;
  module?: CourseModule | null;
}

const ModuleForm: React.FC<ModuleFormProps> = ({
  open,
  onClose,
  onSuccess,
  courseId,
  module,
}) => {
  const api = useApi();
  const store = useStores();

  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(true);

  useEffect(() => {
    if (open) {
      setTitle(module?.title ?? '');
      setDescription(module?.description ?? '');
    }
  }, [open, module]);

  useEffect(() => {
    setDisabled(title.trim() === '');
  }, [title]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      store.notificationsStore.showPreloader();

      if (module) {
        await api.courses.updateModule(
          { title: title.trim(), description: description.trim() },
          module.id,
        );
      } else {
        await api.courses.createModule(courseId, {
          title: title.trim(),
          description: description.trim(),
        });
      }

      store.notificationsStore.setNotifications('Успешно выполнено');
      onSuccess();
      onClose();
    } catch {
      store.notificationsStore.setError('Ошибка при выполнении');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  if (!open) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          <Close />
        </button>
        <h3>{module ? 'Редактировать модуль' : 'Добавить модуль'}</h3>
        <div className={styles.line} />
        <form onSubmit={handleSubmit}>
          <Input
            textLabel="Название"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={{ marginBottom: 16 }}
          />
          <TextArea
            textLabel="Описание"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            style={{ marginBottom: 24 }}
          />
          <Button type="submit" appearance="auth" disabled={disabled}>
            {module ? 'Сохранить' : 'Создать'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ModuleForm;
